var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== null && _vm.value !== undefined)?_c('tr',{staticClass:"loggerDetails"},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.$t(`${_vm.labelName}`)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }